import { h, Fragment } from 'preact';

/**
 * Component for rendering an article image with styling.
 *
 * @component
 * @param {Object} props - The props object.
 * @param {string} props.image - The source URL of the image.
 * @param {string} props.alt - The alt text for the image.
 * @param {'lazy' | 'eager'} [props.loading='lazy'] - Native image loading strategy. Set 'eager' for the first/above-the-fold image so it remains the LCP candidate.
 * @param {'auto' | 'high' | 'low'} [props.fetchpriority='auto'] - Fetch priority hint. Set 'high' on the LCP image.
 * @returns {JSX.Element} A styled image wrapped in a div container.
 */

export const ArticleImage = ({
  image,
  alt,
  loading = 'lazy',
  fetchpriority = 'auto',
}) => {
  return (
    <div className="w-full tw:h-[420px] tw:lg:h-[507px]">
      <img
        src={image}
        alt={alt}
        loading={loading}
        fetchPriority={fetchpriority}
        className="tw:h-full tw:w-full tw:rounded-[20px] tw:object-cover"
      />
    </div>
  );
};
